import { createSlice } from "@reduxjs/toolkit";
import {getSubscriptionDetails} from "../../services";

const subscriptionSlice = createSlice({
    name: "subscription",
    initialState: {
        error: false,
        loading: false,
        details: null,
        lastUpdated: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getSubscriptionDetails.pending, (state) => {
                state.error = false;
                state.loading = true;
                state.details = null;
            })
            .addCase(getSubscriptionDetails.fulfilled, (state, action) => {
                state.details = action.payload;
                state.loading = false;
                state.error = false;
                state.lastUpdated = new Date().toISOString();
            })
            .addCase(getSubscriptionDetails.rejected, (state, action) => {
                state.details = null;
                state.error = action.payload || true;
                state.loading = false;
            });
    },
});

export const { } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;